import { i18n } from '@/config';

export const price = (value, format = 'currency', alwaysNumeric = false) => {
  if (value > 0 || alwaysNumeric) {
    return i18n.global.n(value, format);
  }
  return i18n.global.t('forFree');
};

export const priceStartsFrom = (value, key = 'priceStartsFrom') => {
  const formattedPrice = typeof value === 'number' ? price(value) : value;
  const finalKey = `report.subscription.${key}`;
  return i18n.global.t(finalKey, { price: formattedPrice });
};

export const pricePerPeriod = (items, isList = true) => {
  if (isList) {
    const prices = items.map((item) => item.price / item.period);
    return Math.min(...prices);
  }
  return items.price / items.period;
};
